import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./voter/Home";
import VotingPage from "./voter/VotingPage";
import TrackCastedPage from "./voter/TrackCastedPage";
import TrackBogusPageTest from "./voter/TrackBogusPageTest";
import CandidateForm from "./candidate/CandidateForm";
import ToastProvider from "./common/ToastProvider";
import LoginPage from "./voter/LoginPage";

function App() {
  return (
    <Router>
        {/* 🔹 Toast system globally */}
      <ToastProvider />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/voting" element={<VotingPage />} />
        <Route path="/track-casted" element={<TrackCastedPage />} />
        <Route path="/track-bogus" element={<TrackBogusPageTest />} />
        <Route path="/candidate" element={<CandidateForm />} />
      </Routes>
    </Router>
  );
}

export default App;
